<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import DivWrapper from '../components/divWrapper.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			headline: string | ISbRichtext;
			subheading: string | ISbRichtext;
			text_alignment: 'left' | 'center';
			remove_grid: boolean;
		}>['content'];
	}

	let { content }: Props = $props();

	let WrapperType = $derived(content.remove_grid ? DivWrapper : PageGrid);
</script>

<div
	use:editable={content}
	class="pdp-headline text-brown-1"
	class:text-left={content.text_alignment === 'left'}
	class:text-center={content.text_alignment !== 'left'}
>
	<WrapperType class={WrapperType === DivWrapper ? 'h-full' : ''}>
		<div class="primary col-span-full">
			{#if content.headline}
				<div class="text-balance tracking-[-.32px] lg:tracking-[-.48px]">
					<SbRichtext text={content.headline} />
				</div>
			{/if}

			{#if content.subheading}
				<div class="secondary mt-3 text-brown-4 lg:mt-5">
					<SbRichtext text={content.subheading} />
				</div>
			{/if}
		</div>
	</WrapperType>
</div>

<style lang="scss">
	.pdp-headline {
		div.primary {
			&:global {
				/* "p" => fallback */
				p,
				h1 {
					font-size: 44px;
					line-height: 108%;
					letter-spacing: -0.44px;

					@media (min-width: 768px) {
						font-size: 64px;
						line-height: 110%;
						letter-spacing: -0.64px;
					}
				}
				h2,
				h3,
				h4,
				h5,
				h6 {
					font-size: 28px;
					line-height: 110%;
				}
			}
		}
		div.secondary {
			&:global {
				/* "p" => fallback */
				p,
				h2 {
					font-size: 16px;
					line-height: 140%;
					letter-spacing: -0.16px;

					@media (min-width: 1024px) {
						font-size: 20px;
						line-height: 150%;
						letter-spacing: -0.2px;
					}
				}

				h3,
				h4,
				h5,
				h6 {
					font-size: 24px;
					line-height: 110%;
					font-family: 'Catalogue LL';
					font-weight: theme('fontWeight.normal');
				}
			}
		}
	}
</style>
